import { render, staticRenderFns } from "./NotiAction.vue?vue&type=template&id=3471e878"
import script from "./NotiAction.vue?vue&type=script&lang=js"
export * from "./NotiAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports